import { PublicClientApplication } from '@azure/msal-browser'

const entraConfigurationStorageKey = 'entraConfiguration'

let msalInstance = null

export function saveEntraConfiguration(tenantId, clientId) {
    sessionStorage.setItem(entraConfigurationStorageKey, JSON.stringify({ tenantId, clientId }))
}

export function loadEntraConfiguration() {
    try {
        const raw = sessionStorage.getItem(entraConfigurationStorageKey)
        return raw ? JSON.parse(raw) : null
    } catch {
        return null
    }
}

export function clearEntraConfiguration() {
    sessionStorage.removeItem(entraConfigurationStorageKey)
}

export function getMsalInstance() {
    if (msalInstance) return msalInstance
    const entraConfiguration = loadEntraConfiguration()

    if (entraConfiguration) {
        const tenantId = entraConfiguration.tenantId;
        const clientId = entraConfiguration.clientId;

        const authority = tenantId
            ? `https://login.microsoftonline.com/${tenantId}`
            : 'https://login.microsoftonline.com/common'

        const redirectUrl = window.location.origin;
        msalInstance = new PublicClientApplication({
            auth: {
                clientId: clientId || 'MISSING_ENTRA_CLIENT_ID',
                authority,
                redirectUri: redirectUrl,
                postLogoutRedirectUri: redirectUrl,
                navigateToLoginRequestUrl: false
            },
            cache: {
                cacheLocation: 'sessionStorage',
                storeAuthStateInCookie: false
            }
        })
    }

    return msalInstance
}